export const MODES = {
  CREATE: "MODES.CREATE",
  CLONE: "MODES.CLONE",
  EDIT: "MODES.EDIT",
  READ: "MODES.READ"
};

export const ROW_STATE = {
  NEW: "ROW_STATE.NEW",
  APPLY_EXISTING: "ROW_STATE.APPLY_EXISTING",
  VIEW: "ROW_STATE.VIEW",
  EDIT: "ROW_STATE.EDIT",
  DELETE: "ROW_STATE.DELETE"
};
